<div class="cardinal-formio" [ngClass]="{
    'close-action': haveCloseAction,
    'hide-pdf-zoom': !showZoomControls
  }">
    <div id='formio' #formio></div>
</div>
